class DiscreteRange {
	
	constructor( values ) {
		this.values_ = (values || []).map(value => new Date(value));
	}
	
	get start() {
		return this.values[0];
	}
	
	get end() {
		return this.values.at(-1);
	}	
	
	get values() {	
		return this.values_;
	}
}

export { 
	DiscreteRange
}


